import React from 'react';
import { cls } from '../../../packages/components';
import Asset from '../../../requests/apa/Asset';
import './styles/cardBlockedChannel.scss';

const getAssetLock = () => {
    return Asset.get('playingLive_channel_option_button_lockChannel', '/images/ic_block.png');
};

const CardBlockedChannel = () => {
    return (
        <div className={cls('aaf-main-search-card-event-live-main-image-div-block')}>
            <div className="aaf_main_search_content_icon_lock">
                <img
                    src={getAssetLock()}
                    className={cls('aaf_main_search_content_icon_lock_asset')}
                    alt="icon_lock"
                />
            </div>
        </div>
    );
};

export default CardBlockedChannel;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardBlockedChannel.tsx